import FeedviewConfig from './FeedviewConfig';

export default FeedviewConfig;
